// ============================================
// Class Name Utility
// Combines class names conditionally (like clsx/classnames)
// ============================================

type ClassValue = string | number | boolean | undefined | null | ClassValue[];

/**
 * Combines class names conditionally
 * @example
 * cn('base', condition && 'conditional', 'always')
 * // => 'base conditional always' or 'base always'
 */
export function cn(...inputs: ClassValue[]): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === 'string' || typeof input === 'number') {
      classes.push(String(input));
    } else if (Array.isArray(input)) {
      const nested = cn(...input);
      if (nested) classes.push(nested);
    }
  }

  return classes.join(' ');
}
